import { useCallback, useState } from 'react';

import { useBoolean } from 'utils/genericUtils';

import { GEO_API } from '../apiGeo/constants';
import { useCancelablePromise } from '../useCancelablePromise';
import { popErrorMessage } from '../utils/backAlertMessage';

interface Commune {
  nom: string;
  codesPostaux: Array<string>;
}

type CommuneFetcher = (commune: string) => void;

export const useCommune = (): [Array<Commune>, boolean, CommuneFetcher] => {
  const [communes, setCommunes] = useState<Array<Commune>>([]);
  const [value, setValue] = useState<string>('');

  const {
    value: isFetching,
    setIsTrue: startIsFetching,
    setIsFalse: stopIsFetching,
  } = useBoolean();

  const onFetch = () => {
    const url = `${GEO_API}/communes?nom=${encodeURI(
      value,
    )}&fields=nom,codesPostaux&boost=population&format=json&limit=8`;
    startIsFetching();
    return fetch(url);
  };

  const onSuccess = (response: Response) => {
    response
      .json()
      .then((result: Array<Commune>) => {
        setCommunes(result);
      })
      .catch((reason: string) => {
        popErrorMessage(
          `Une erreur lors du parsing des données d'autocomplétion est survenue : ${reason}`,
        );
      });
  };

  const onError = (reason: string) => {
    console.error(
      `Une erreur lors de la récupération des données d'autocomplétion est survenue : ${reason}`,
    );
  };

  useCancelablePromise(
    value === '' ? null : value,
    onFetch,
    onSuccess,
    onError,
    stopIsFetching,
    stopIsFetching,
    500,
  );

  const fetchOptions = useCallback((str: string) => {
    startIsFetching();
    setValue(str);
    setCommunes([]);
  }, []);

  return [communes, isFetching, fetchOptions];
};
